/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { ArrowLeftIcon } from 'shared/components/Icons';
import { useTranslation } from 'react-i18next';
import { API, graphqlOperation } from 'aws-amplify';
import { getError } from 'utils/appHelpers';
import { getUser, getUserProjects } from 'graphql/user/queries';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import TabsNavigation from 'shared/components/layout/TabsNavigation';
import ProjectsTab from './components/ProjectsTab';
import PollsTab from './components/PollsTab';
import UserInfoBlock from './components/UserInfoBlock';

const UserView = ({ match, history }) => {
  const { t } = useTranslation();
  const alert = useAlert();
  const userId = match.params?.id;
  const [activeTab, setActiveTab] = useState('projects');
  const [user, setUser] = useState();

  const tabs = [
    {
      name: 'tab_projects',
      state: 'projects',
      count: user?.projects?.items?.length,
    },
    // {
    //   name: 'tab_polls',
    //   state: 'polls',
    //   count: user?.polls?.items?.length,
    // },
  ];

  const goBack = () => {
    history.goBack();
  };

  const getUserData = async id => {
    try {
      const body = { limit: 1000, id };
      const { data } = await API.graphql(graphqlOperation(getUser, body));
      const projects = await API.graphql(graphqlOperation(getUserProjects, { userId: id }));
      data.getUser.projects = projects.data.getUser.projects;
      setUser(data.getUser);
    } catch (err) {
      alert.error(getError(err));
    }
  };

  const onChangeTab = item => {
    setActiveTab(item.state);
  };

  useEffect(() => {
    getUserData(userId);
  }, [userId]);

  return (
    <div className='user-view'>
      <div>
        <div className='cursor-pointer d-inline p-0 fw-300' onClick={goBack}>
          <ArrowLeftIcon /> {t('text_back')}
        </div>
      </div>
      {!user ? (
        <SkeletonLoader type='page' count={3} className='mt-20' />
      ) : (
        <>
          <UserInfoBlock user={user} getUserData={getUserData} className='mt-10' />
          <div className='mt-15'>
            <TabsNavigation className='mb-15' items={tabs} activeItem={activeTab} onItemClick={onChangeTab} />
          </div>
          {activeTab === 'polls' && <PollsTab polls={user?.polls?.items} />}
          {activeTab === 'projects' && <ProjectsTab userId={userId} projects={user?.projects?.items} />}
        </>
      )}
    </div>
  );
};

export default UserView;
